var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopNavigationCartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_430_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31958 1.29796H4.37514L6.42236 11.5264C6.49221 11.8781 6.68354 12.194 6.96284 12.4189C7.24215 12.6437 7.59164 12.7632 7.95013 12.7563H15.3751C15.7336 12.7632 16.0831 12.6437 16.3624 12.4189C16.6417 12.194 16.8331 11.8781 16.9029 11.5264L18.1251 5.1174H5.13902M8.19458 16.5757C8.19458 16.9976 7.85257 17.3396 7.43069 17.3396C7.00881 17.3396 6.6668 16.9976 6.6668 16.5757C6.6668 16.1539 7.00881 15.8118 7.43069 15.8118C7.85257 15.8118 8.19458 16.1539 8.19458 16.5757ZM16.5974 16.5757C16.5974 16.9976 16.2554 17.3396 15.8335 17.3396C15.4116 17.3396 15.0696 16.9976 15.0696 16.5757C15.0696 16.1539 15.4116 15.8118 15.8335 15.8118C16.2554 15.8118 16.5974 16.1539 16.5974 16.5757Z",
    stroke: "white",
    strokeWidth: 1.81424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_430_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3333,
    height: 18.3333,
    fill: "white",
    transform: "translate(0.555664 0.534073)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavigationCartIcon);
export default __webpack_public_path__ + "static/media/top-navigation-cart-icon.24ee579833cabcf4b267fb43e6b505d2.svg";
export { ForwardRef as ReactComponent };